export const notShowErrorsRequests = [
    {
        url: 'admin/files/folder',
        method: 'post'
    },
]
